// @ts-check
import BlockCard from '../BlockCard';

// Order and labels follow the backend VendorOrderStatus enum. The admin build cannot import /shared.
const STATUSES = [
  ['draft', 'Draft'],
  ['sent', 'Sent'],
  ['confirmed', 'Confirmed'],
  ['in_production', 'In production'],
  ['ready_for_pickup', 'Ready for pickup'],
  ['delivered', 'Delivered'],
  ['completed', 'Completed'],
  ['cancelled', 'Cancelled'],
];

// Keyed by status name so a colour never shifts when another status is absent.
const BAR_CLASS = {
  draft: 'bg-slate-400',
  sent: 'bg-blue-500',
  confirmed: 'bg-indigo-500',
  in_production: 'bg-amber-500',
  ready_for_pickup: 'bg-orange-500',
  delivered: 'bg-green-500',
  completed: 'bg-emerald-600',
  cancelled: 'bg-red-400',
};
const FALLBACK_BAR = 'bg-primary';

/** Status bar of vendor order counts, with the number still open. */
export default function VendorsBlock({ block }) {
  const { by_status: byStatus = {}, open = 0 } = block.data || {};
  const known = new Set(STATUSES.map(([k]) => k));
  const rows = [
    ...STATUSES.filter(([k]) => byStatus[k] > 0).map(([k, label]) => ({ key: k, label, count: byStatus[k] })),
    // Statuses added to the backend enum later still show, with a readable fallback label.
    ...Object.keys(byStatus).filter((k) => !known.has(k) && byStatus[k] > 0).map((k) => ({ key: k, label: k.replace(/_/g, ' '), count: byStatus[k] })),
  ];
  const max = Math.max(0, ...rows.map((r) => r.count));

  return (
    <BlockCard title="Vendors" href={block.href} headline={block.headline}>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground">No vendor orders yet</p>
      ) : (
        <>
          <ul className="space-y-2">
            {rows.map((r) => (
              <li key={r.key} data-testid="vendors-status" data-status={r.key} className="text-sm">
                <div className="flex items-center justify-between">
                  <span>{r.label}</span>
                  <span className="font-medium">{r.count}</span>
                </div>
                <div className="mt-1 h-2 rounded bg-muted">
                  <div data-testid="vendors-bar" className={`h-2 rounded ${BAR_CLASS[r.key] || FALLBACK_BAR}`} style={{ width: `${(r.count / max) * 100}%` }} />
                </div>
              </li>
            ))}
          </ul>
          <p className="mt-3 text-sm text-muted-foreground" data-testid="vendors-open">
            {open} open
          </p>
        </>
      )}
    </BlockCard>
  );
}
